import {
  REQUEST_SOURCE_BASE_DATA,
  REQUEST_SOURCE_BASE_DATA_ERROR,
  RECEIVE_SOURCE_BASE_DATA
} from 'actions'
import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'

const reducer = createApiMiddlewareReducer({
  request: REQUEST_SOURCE_BASE_DATA,
  failure: REQUEST_SOURCE_BASE_DATA_ERROR,
  receive: RECEIVE_SOURCE_BASE_DATA
})

export default function (state = {}, action) {
  const { type, payload = {} } = action

  // payload can be any type, includ null (https://github.com/acdlite/flux-standard-action#payload)
  // here, if payload === null, this reducer throws
  if (payload === null) return state

  const { workspaceSlug, sourceMetadataSlug } = payload
  const key = `${workspaceSlug}-${sourceMetadataSlug}`

  switch (type) {
    case REQUEST_SOURCE_BASE_DATA:
    case REQUEST_SOURCE_BASE_DATA_ERROR:
    case RECEIVE_SOURCE_BASE_DATA:
      return {
        ...state,
        [key]: reducer(state[key], action)
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/source-settings-base-data.js